/**
 * Classifies the corner of each product-card image behind the wishlist
 * heart as "light" or "dark", so the heart can switch between a solid
 * black or white icon instead of relying on mix-blend-mode: difference
 * (which tints toward the inverse color rather than a clean black/white).
 *
 * Also classifies the second ("hover preview") image separately and swaps
 * the heart's contrast class in sync with the card's own hover crossfade,
 * so the heart stays visible even when the second image has a different
 * background than the first.
 */
(function () {
  if (window.__gbWishlistContrastInit) return;
  window.__gbWishlistContrastInit = true;

  var THRESHOLD = 0.6;
  var SAMPLE = 16;
  // Fraction of the image (from the top-left corner) to sample, roughly
  // matching the area the heart button actually sits in front of.
  var CROP_FRACTION = 0.35;

  function luminance(r, g, b) {
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  }

  function classifyImage(img, callback) {
    var src = img.currentSrc || img.src;
    if (!src) return;

    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var canvas = document.createElement('canvas');
        canvas.width = SAMPLE;
        canvas.height = SAMPLE;
        var ctx = canvas.getContext('2d');
        if (!ctx) return;

        var cropW = probe.naturalWidth * CROP_FRACTION;
        var cropH = probe.naturalHeight * CROP_FRACTION;
        ctx.drawImage(probe, 0, 0, cropW, cropH, 0, 0, SAMPLE, SAMPLE);

        var data = ctx.getImageData(0, 0, SAMPLE, SAMPLE).data;
        var total = 0;
        var count = 0;
        for (var i = 0; i < data.length; i += 4) {
          total += luminance(data[i], data[i + 1], data[i + 2]);
          count++;
        }
        var average = total / count;

        callback(average < THRESHOLD ? 'dark' : 'light');
      } catch (error) {
        // Canvas read blocked (e.g. CORS) - leave unclassified.
      }
    };
    probe.src = src;
  }

  function whenReady(img, fn) {
    if (img.complete && img.naturalWidth > 0) {
      fn();
    } else {
      img.addEventListener('load', fn, { once: true });
    }
  }

  function applyContrast(button, value) {
    if (!value) return;
    button.classList.toggle('gb-wishlist-button--on-dark', value === 'dark');
    button.classList.toggle('gb-wishlist-button--on-light', value === 'light');
  }

  // Only the slides that could actually be shown (skips variant-specific
  // slides still hidden via the native "hidden" attribute), in DOM order.
  function findVisibleImages(button) {
    var card = button.closest('.card-gallery');
    if (!card) return [];
    var slides = card.querySelectorAll('slideshow-slide:not([hidden])');
    var images = [];
    slides.forEach(function (slide) {
      var img = slide.querySelector('img');
      if (img) images.push(img);
    });
    return images;
  }

  function setup(button) {
    if (button.dataset.gbContrastSetup) return;
    button.dataset.gbContrastSetup = 'true';

    var images = findVisibleImages(button);
    var primaryImg = images[0];
    var secondaryImg = images[1];
    if (!primaryImg) return;

    whenReady(primaryImg, function () {
      classifyImage(primaryImg, function (value) {
        button.dataset.gbContrastPrimary = value;
        if (!button.classList.contains('gb-wishlist-button--hover-active')) {
          applyContrast(button, value);
        }
      });
    });

    if (!secondaryImg) return;

    var secondaryRequested = false;
    function classifySecondary() {
      if (secondaryRequested) return;
      secondaryRequested = true;
      whenReady(secondaryImg, function () {
        classifyImage(secondaryImg, function (value) {
          button.dataset.gbContrastSecondary = value;
          if (button.classList.contains('gb-wishlist-button--hover-active')) {
            applyContrast(button, value);
          }
        });
      });
    }

    var card = button.closest('.card-gallery');
    if (!card) return;

    card.addEventListener('pointerenter', function (event) {
      if (event.pointerType !== 'mouse') return;
      button.classList.add('gb-wishlist-button--hover-active');
      classifySecondary();
      applyContrast(button, button.dataset.gbContrastSecondary);
    });

    card.addEventListener('pointerleave', function (event) {
      if (event.pointerType !== 'mouse') return;
      button.classList.remove('gb-wishlist-button--hover-active');
      applyContrast(button, button.dataset.gbContrastPrimary);
    });
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setup(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '200px' }
  );

  function scan(root) {
    (root || document).querySelectorAll('.gb-wishlist-button--product-card').forEach(function (button) {
      observer.observe(button);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  // Re-scan when Shopify re-renders sections (filtering, quick add,
  // theme editor updates) so new cards get classified too.
  document.addEventListener('shopify:section:load', function () {
    scan();
  });
})();
